import Provider from '../../utils/recordContext';
// import getChildren from '../../utils/children';
import React from 'react';

const RecordList = props => <Provider targets={props.targets} content={props.content} useForFilter={props.useForFilter} />
export default RecordList;
